import { City } from "./city";

export class State {
    stateCode: string="";
    stateDesc: string="";
    stateDescHN: string="";
}